import { SporsmalType, TriggeredByType } from '../../types/generated-types';
import { SporsmalsGruppe, UtsattForgreiningsporsmal } from '../reducer/sporsmalsflyt-types';
import { TriggeredByUtsattForgreining } from '../reducer/triggeredby-types';

export interface CurrentUtsattForgreiningsporsmal {
    type: SporsmalType.UtsattForgreining;
    sporsmal: UtsattForgreiningsporsmal;
}

export interface SporsmalsGruppeTriggeredByUtsattForgreining extends SporsmalsGruppe {
    triggeredBy: TriggeredByUtsattForgreining;
}

export const isSporsmalsGruppeTriggeredByUtsattForgreining = (
    s: SporsmalsGruppe,
): s is SporsmalsGruppeTriggeredByUtsattForgreining => s.triggeredBy.type === TriggeredByType.UtsattForgreining;
